import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IFilter,
  IPopulate,
  IQueryParam,
  ITracker,
  IActivo,
  IReporteGenerico,
  IReporteBase,
  IEventoGenerico,
} from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { SetearOdometroComponent } from './setear-odometro/setear-odometro.component';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { isModoDesactivadoActivo } from '../../../../../auxiliares/modo-desactivado.util';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import {
  MapaFacilData,
  Coordinate,
} from '../../../../../auxiliares/mapa-facil/interfaces';
import { MapaFacilDialogComponent } from '../../../../../auxiliares/mapa-facil-dialog/mapa-facil-dialog.component';
import { ActivosService } from '../../../../../auxiliares/servicios/http/activos.service';
import { LoginService } from '../../../../login/login.service';
import { ModoDesactivadoDispositivoComponent } from '../../../../standalone/modo-desactivado-dispositivo/modo-desactivado-dispositivo.component';
import { DarAltaVehiculoComponent } from '../../../vehiculos/dar-alta-vehiculo/dar-alta-vehiculo.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import {
  CrearEditarEventoTecnicoGenericoComponent,
  ICrearEditarEventoTecnicoGenericoData,
} from '../../../eventos-genericos/eventos-tecnicos-genericos/crear-editar/crear-editar-evento-tecnico-generico.component';
import { EventosGenericosHttpService } from '../../../../../auxiliares/servicios/http/eventos-genericos.service';
import { ReportesGenericosService } from '../../../../../auxiliares/servicios/http/reportes-genericos.service';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import {
  estadoConexionCelda,
  estadoHtml,
  fechaCelda,
  haceCelda,
} from '../../../../../auxiliares/tabla/celdas';
import { IEstadoCelda } from '../../../../../auxiliares/tabla/tabla.interfaces';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';

interface IActivoTabla extends IActivo {
  ultimoReporte?: IReporteBase<'Tracker 4G'>;
  color?: string;
}

@Component({
  selector: 'app-listado-colectivos',
  templateUrl: './listado-colectivos.component.html',
  styleUrl: './listado-colectivos.component.scss',
  standalone: false,
})
export class ListadoColectivosComponent implements OnInit, OnDestroy {
  private formularios = inject(FormularioDialogService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ActivosService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private eventosService = inject(EventosGenericosHttpService);
  private reportesService = inject(ReportesGenericosService);

  public clientePropio = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoColectivosComponent';
  public totalCount = 0;
  public columnas?: IColumnas<IActivoTabla>[];
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Colectivos - Crear'),
    tooltip: 'Crear colectivo',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  // Query Tabla
  public activos?: IActivoTabla[];
  public filter: IFilter<IActivo> = {};
  public populate: IPopulate[] = [
    {
      path: 'tracker',
    },
    { path: 'vehiculo.recorrido', select: 'nombre' },
    { path: 'vehiculo.recorridos', select: 'nombre' },
    { path: 'grupo', select: 'nombre' },
    { path: 'vehiculo.chofer', select: 'usuario' },
    { path: 'cliente', select: 'nombre' },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'identificacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };
  // FILTROS TABLA
  public search: IRegExpSearch = {
    fields: ['identificacion', 'vehiculo.patente'],
  };
  public estado: IFiltroTabla = {
    elementos: [
      { value: 'Operativo' },
      { value: 'En mantenimiento' },
      { value: 'Fuera de servicio' },
    ],
    filter: {
      field: 'vehiculo.estado',
    },
    label: 'Estado',
    rapido: true,
    selectLabel: 'value',
    selectValue: 'value',
    tipo: 'select',
  };
  public grupo: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idGrupo',
    },
    label: 'Línea',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'grupos',
    searchOn: ['nombre'],
  };
  public recorrido: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'vehiculo.idRecorrido',
    },
    label: 'Recorrido',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'recorridos',
    searchOn: ['nombre'],
  };
  public chofer: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'vehiculo.idChofer',
    },
    label: 'Chofer',
    selectLabel: 'usuario',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'usuarios',
    searchOn: ['usuario'],
  };
  public tracker: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idTracker',
    },
    label: 'Tracker',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'trackers',
    searchOn: ['nombre'],
  };
  private alta: IFiltroTabla = {
    elementos: [
      {
        label: 'Dado de alta',
        value: [{ fechaAlta: { $exists: true, $ne: null } }],
      },
      { label: 'Sin alta', value: [{ fechaAlta: null }] },
    ],
    filter: {
      field: '$or',
    },
    label: 'Alta',
    rapido: true,
    tipo: 'ngselect',
    selectLabel: 'label',
    selectValue: 'value',
  };
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloColectivos'],
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [
    this.estado,
    this.grupo,
    this.recorrido,
    this.tracker,
    this.chofer,
    this.alta,
  ];

  // Subscripciones
  public activos$?: Subscription;
  public reportes$?: Subscription;
  public grupos$?: Subscription;
  public recorridos$?: Subscription;
  public trackers$?: Subscription;
  public choferes$?: Subscription;

  // Listados para filtros
  public async listarGrupos(): Promise<void> {
    const query: IQueryParam = {
      select: 'nombre',
      sort: 'nombre',
      limit: 0, // Sin limite
      includeChildren: true,
    };

    this.grupos$?.unsubscribe();
    this.grupos$ = this.lista2.grupos(query, 30).subscribe((data) => {
      this.grupo.elementos = data.datos;
    });
  }
  public async listarRecorridos(): Promise<void> {
    const query: IQueryParam = {
      select: 'nombre',
      sort: 'nombre',
      limit: 0, // Sin limite
      includeChildren: true,
    };

    this.recorridos$?.unsubscribe();
    this.recorridos$ = this.lista2.recorridos(query, 30).subscribe((data) => {
      this.recorrido.elementos = data.datos;
    });
  }
  public async listarTrackers(): Promise<void> {
    const filter: IFilter<ITracker> = {
      $or: [{ tipo: 'GPRS' }, { tipo: { $exists: false } }],
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      select: 'nombre identificacion',
      sort: 'nombre',
      limit: 0, // Sin limite
      includeChildren: true,
    };

    this.trackers$?.unsubscribe();
    this.trackers$ = this.lista2.trackers(query, 30).subscribe((data) => {
      this.tracker.elementos = data.datos;
    });
  }
  public async listarChoferes(): Promise<void> {
    const query: IQueryParam = {
      select: 'usuario',
      sort: 'usuario',
      limit: 0, // Sin limite
      includeChildren: true,
    };

    this.choferes$?.unsubscribe();
    this.choferes$ = this.lista2.chofers(query, 30).subscribe((data) => {
      this.chofer.elementos = data.datos;
    });
  }

  //

  public async listar(): Promise<void> {
    this.activos$?.unsubscribe();
    this.activos$ = this.lista2
      .colectivos(this.query, 30)
      .subscribe(async (data) => {
        this.totalCount = data.totalCount;
        await this.completaUltimoReporte(data.datos);
      });
  }

  private async completaUltimoReporte(activos: IActivoTabla[]): Promise<void> {
    // Sin resultados (p. ej. filtro 'Sin alta' sin colectivos) la tabla tiene
    // que quedar vacía: antes se salía sin asignar y quedaba con los datos
    // anteriores y la barra de carga girando, como tildada.
    if (!activos?.length) {
      this.activos = [];
      return;
    }

    const idsActivos = activos.map((v) => v._id);
    const filter: IFilter<IReporteGenerico> = {
      idsAsignados: { $in: idsActivos },
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: '-fechaCreacion',
      includeChildren: true,
    };

    const data = await firstValueFrom(
      this.lista2.ultimosReportesGenericos<'Tracker 4G'>(query),
    );
    for (const activo of activos) {
      const findReporte = data.datos.find((r) =>
        r.idsAsignados.includes(activo._id),
      );
      activo.ultimoReporte = findReporte;
      if (activo.ultimoReporte) {
        const frecuenciaReporte = activo?.tracker?.frecReporte;
        const timeReporte = new Date(
          activo?.ultimoReporte?.fechaCreacion,
        ).getTime();
        const timeNow = new Date().getTime();
        const diff = timeNow - timeReporte;
        const frecuenciaEnMs = frecuenciaReporte * 60 * 1000;
        if (diff > 2 * frecuenciaEnMs) {
          activo.color = 'red';
        } else if (diff > frecuenciaEnMs && diff < 2 * frecuenciaEnMs) {
          activo.color = 'yellow';
        } else if (diff < frecuenciaEnMs) {
          activo.color = 'green';
        } else {
          activo.color = 'black';
        }
      }
    }
    this.activos = activos;
  }

  // Acciones
  public async crear() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async editar(vehiculo: IActivo) {
    this.navigator.navigate(['editar', vehiculo._id], {
      relativeTo: this.route,
    });
  }

  public async modoDesactivado(activo: IActivo) {
    this.formularios.abrir(ModoDesactivadoDispositivoComponent, {
      tamano: 'chico',
      data: { activo: activo },
    });
  }

  public verDetalles(colectivo: IActivo): void {
    this.navigator.navigate([
      'main/colectivos/colectivos/detalles',
      colectivo._id,
    ]);
  }

  public async darAlta(activo: IActivo) {
    this.formularios.abrir(DarAltaVehiculoComponent, {
      tamano: 'mediano',
      data: {
        edit: activo,
      },
    });
  }

  public async ubicar(c: IActivoTabla) {
    if (!c.ultimoReporte?.valores?.geojson?.coordinates) return;
    const coord = [
      c.ultimoReporte?.valores?.geojson?.coordinates[0],
      c.ultimoReporte?.valores?.geojson?.coordinates[1],
    ] as Coordinate;
    const data: MapaFacilData = {
      markers: [{ coor: coord, label: 'vehiculo' }],
    };
    this.formularios.abrir(MapaFacilDialogComponent, {
      tamano: 'grande',
      data,
      cerrarAfuera: true,
    });
  }

  public async eliminar(activo: IActivo) {
    const res = await this.dialogService.confirm(
      'Eliminar vehículo',
      `¿Querés eliminar el vehículo ${activo.identificacion}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(activo._id!);
      this.helper.notifSuccess('Vehículo eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async setearOdometro(vehiculo: IActivo) {
    this.formularios.abrir(SetearOdometroComponent, {
      tamano: 'chico',
      data: vehiculo,
    });
  }

  public ventanaDocumentos(data: IActivo) {
    this.navigator.navigate([
      '/',
      'main',
      'documentos',
      'listar',
      'vehiculo',
      data._id,
    ]);
  }

  public async eventoTecnico(activo: IActivo) {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      idEntidad: activo._id!,
      tipoEvento: 'Evento Técnico Tracker',
      categoria: 'Tracker',
      idsCQAET: [this.clientePropio!._id!],
    };

    this.formularios.abrir(CrearEditarEventoTecnicoGenericoComponent, {
      tamano: 'grande',
      data,
    });
  }

  public async exportarEventos(activo: IActivo) {
    const rango = await this.dialogService.dateRange(
      'Exportar Eventos',
      'Seleccioná el rango de fechas para exportar los eventos',
    );
    if (!rango) return;

    const filter: IFilter<IEventoGenerico> = {
      idEntidad: activo._id,
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'activo',
        select: 'identificacion',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Fecha',
          key: 'fechaCreacion',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Tipo Evento',
          key: 'tipoEvento',
        },
        {
          header: 'Estado',
          key: 'estado',
        },
        {
          header: 'Fecha Evento',
          key: 'valores.timestamp',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Categoría',
          key: 'categoria',
          placeholder: 'Sin categoría',
        },
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Entidad',
          key: 'activo.identificacion',
        },
        {
          header: 'Título',
          key: 'valores.titulo',
          placeholder: 'Sin título',
        },
        {
          header: 'Detalles',
          key: 'valores.mensaje',
          placeholder: 'Sin detalles',
        },
      ],
      sheetName: 'Eventos',
      autoFilter: true,
    };

    try {
      await this.eventosService.exportar(query, config, activo.identificacion);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async exportarReportes(activo: IActivo) {
    const rango = await this.dialogService.dateRange(
      'Exportar Reportes',
      'Seleccioná el rango de fechas para exportar los reportes',
    );
    if (!rango) return;

    const filter: IFilter<IReporteGenerico> = {
      idEntidad: activo._id,
      tipoReporte: {
        $in: ['Tracker 4G', 'Tracker T1000B', 'Tracker Qualcomm'],
      },
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'activo',
        select: 'identificacion',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Fecha',
          key: 'fechaCreacion',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Tipo Reporte',
          key: 'tipoReporte',
        },
        {
          header: 'Tipo Entidad',
          key: 'tipoEntidad',
        },
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Entidad',
          key: 'activo.identificacion',
        },
        {
          header: 'Latitud',
          key: 'valores.geojson.coordinates.1',
          placeholder: '0',
        },
        {
          header: 'Longitud',
          key: 'valores.geojson.coordinates.0',
          placeholder: '0',
        },
        {
          header: 'Dirección',
          key: 'valores.direccion',
          placeholder: 'Sin dirección',
        },
        {
          header: 'Velocidad (km/h)',
          key: 'valores.velocidad',
          transform: 'velocidad' as const,
          placeholder: '0',
        },
        {
          header: 'Orientación',
          key: 'valores.orientacion',
          transform: 'orientacionBrujula' as const,
          placeholder: '-',
        },
        {
          header: 'Batería Externa (%)',
          key: 'valores.bateriaExterna',
          transform: 'porcentaje' as const,
          placeholder: '0',
        },
        {
          header: 'Batería Interna (%)',
          key: 'valores.bateriaInterna',
          transform: 'porcentaje' as const,
          placeholder: '0',
        },
        {
          header: 'Ignición',
          key: 'valores.ignicion',
          transform: 'booleanSiNo' as const,
          placeholder: 'Desconocido',
        },
        {
          header: 'Señal GSM',
          key: 'valores.senialGSM',
          placeholder: '0',
        },
        {
          header: 'Señal GPS',
          key: 'valores.senialGPS',
          placeholder: '0',
        },
        {
          header: 'Odómetro (km)',
          key: 'valores.odometro',
          transform: 'kilometros' as const,
          placeholder: '0',
        },
      ],
      sheetName: 'Reportes',
      autoFilter: true,
    };

    try {
      await this.reportesService.exportar(query, config, activo.identificacion);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  /** Estado operativo del colectivo con su nombre real (sin mayúsculas). */
  private estadoOperativo(dato: IActivoTabla): IEstadoCelda | undefined {
    const estado = dato.vehiculo?.estado;
    if (!estado) return undefined;
    switch (estado) {
      case 'Operativo':
        return { texto: estado, tono: 'ok', icono: 'check_circle' };
      case 'En mantenimiento':
        return { texto: estado, tono: 'aviso', icono: 'warning' };
      case 'Fuera de servicio':
        return { texto: estado, tono: 'error', icono: 'block' };
      default:
        return { texto: estado, tono: 'info', icono: 'info' };
    }
  }

  private setColumnas() {
    const columnas: IColumnas<IActivoTabla>[] = [
      // Identificación + Patente + Estado operativo
      {
        header: {
          label: 'Colectivo',
          sortable: true,
          sort: 'identificacion',
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-col">`;
            html += dato.identificacion
              ? `<span class="tabla-principal">${escaparHtml(dato.identificacion)}</span>`
              : `<span class="no-info">Sin identificación</span>`;

            if (dato.vehiculo?.patente) {
              html += `<span class="tabla-codigo">${escaparHtml(this.helper.formatPatente(dato.vehiculo.patente))}</span>`;
            }

            const estado = this.estadoOperativo(dato);
            if (estado) {
              html += `<span>${estadoHtml(estado)}</span>`;
            }

            if (isModoDesactivadoActivo(dato.modoDesactivado)) {
              html += `<span>${estadoHtml({ texto: 'Desactivado', tono: 'neutro', icono: 'do_not_disturb_on' })}</span>`;
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato.identificacion)
              items.push(
                `<div>Identificación: <strong>${escaparHtml(dato.identificacion)}</strong></div>`,
              );
            if (dato.vehiculo?.patente)
              items.push(
                `<div>Patente: <strong>${escaparHtml(this.helper.formatPatente(dato.vehiculo.patente))}</strong></div>`,
              );
            if (dato.vehiculo?.estado)
              items.push(
                `<div>Estado: <strong>${escaparHtml(dato.vehiculo.estado)}</strong></div>`,
              );
            if (isModoDesactivadoActivo(dato.modoDesactivado))
              items.push(`<div><strong>Dispositivo desactivado</strong></div>`);
            return items.length > 0 ? items.join('') : undefined;
          },
        },
      },

      // Detalles (Tracker + Línea/Grupo) + Ignición
      {
        header: {
          label: 'Detalles',
          sortable: false,
        },
        row: {
          html: (dato) => {
            const trackerNombre =
              dato.tracker?.nombre || dato.tracker?.identificacion;
            const ignicion = dato.ultimoReporte?.valores?.ignicion;
            const hayIgnicion = ignicion !== undefined && ignicion !== null;
            if (!hayIgnicion && !trackerNombre && !dato.grupo?.nombre) {
              return '';
            }

            let html = `<div class="tabla-celda-fila">`;

            // Ícono de ignición (el mismo que en vehículos)
            if (hayIgnicion) {
              const ignicionOn = ignicion === true;
              const iconColor = ignicionOn
                ? 'var(--color-green-icon)'
                : 'var(--color-gray-icon)';
              const iconName = ignicionOn ? 'key' : 'key_off';
              const title = ignicionOn
                ? 'Ignición encendida'
                : 'Ignición apagada';
              html += `<span class="material-symbols-outlined tabla-icono-dato" style="color: ${iconColor};" title="${title}">${iconName}</span>`;
            }

            // Información del colectivo
            html += `<div class="tabla-celda-col">`;

            if (trackerNombre) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">gps_fixed</span>
                <span>${escaparHtml(trackerNombre)}</span>
              </div>`;
            }

            if (dato.grupo?.nombre) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">workspaces</span>
                <span>Línea ${escaparHtml(dato.grupo.nombre)}</span>
              </div>`;
            }

            html += `</div></div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];

            const ignicion = dato.ultimoReporte?.valores?.ignicion;
            if (ignicion !== undefined && ignicion !== null) {
              items.push(
                `<div>Ignición: <strong>${ignicion === true ? 'Encendida' : 'Apagada'}</strong></div>`,
              );
            }

            if (dato.tracker?.nombre || dato.tracker?.identificacion)
              items.push(
                `<div>Tracker: <strong>${escaparHtml(dato.tracker?.nombre || dato.tracker?.identificacion)}</strong></div>`,
              );
            if (dato.grupo?.nombre)
              items.push(
                `<div>Línea: <strong>${escaparHtml(dato.grupo.nombre)}</strong></div>`,
              );

            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin tracker ni línea',
        },
      },

      // Recorridos + Chofer
      {
        header: {
          label: 'Asignación',
          sortable: false,
        },
        row: {
          html: (dato) => {
            const recorridosNombres = (dato.vehiculo?.recorridos ?? [])
              .map((r) => r.nombre)
              .filter(Boolean)
              .join(', ');
            if (
              !dato.vehiculo?.recorrido?.nombre &&
              !recorridosNombres &&
              !dato.vehiculo?.chofer?.usuario
            ) {
              return '';
            }

            let html = `<div class="tabla-celda-col">`;

            // Recorrido principal
            if (dato.vehiculo?.recorrido?.nombre) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">route</span>
                <span>${escaparHtml(dato.vehiculo.recorrido.nombre)}</span>
              </div>`;
            }

            // Recorridos adicionales
            if (recorridosNombres) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">route</span>
                <span>${escaparHtml(recorridosNombres)}</span>
              </div>`;
            }

            // Chofer
            if (dato.vehiculo?.chofer?.usuario) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">account_box</span>
                <span>${escaparHtml(dato.vehiculo.chofer.usuario)}</span>
              </div>`;
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato.vehiculo?.recorrido?.nombre)
              items.push(
                `<div>Recorrido: <strong>${escaparHtml(dato.vehiculo.recorrido.nombre)}</strong></div>`,
              );
            if (
              dato.vehiculo?.recorridos &&
              dato.vehiculo.recorridos.length > 0
            ) {
              const recorridosNombres = dato.vehiculo.recorridos
                .map((r) => r.nombre)
                .join(', ');
              if (recorridosNombres)
                items.push(
                  `<div>Recorridos: <strong>${escaparHtml(recorridosNombres)}</strong></div>`,
                );
            }
            if (dato.vehiculo?.chofer?.usuario)
              items.push(
                `<div>Chofer: <strong>${escaparHtml(dato.vehiculo.chofer.usuario)}</strong></div>`,
              );
            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin asignaciones',
        },
      },

      // Comunicación + fecha de alta (combinados)
      {
        header: {
          label: 'Estado',
          sortable: true,
          sort: 'fechaAlta',
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-col">`;

            // Comunicación: el mismo criterio que el detalle del colectivo,
            // con la fecha del último reporte y "hace x"
            const fechaReporte = dato.ultimoReporte?.fechaCreacion;
            html += `<span>${estadoHtml(estadoConexionCelda(fechaReporte, dato.tracker?.frecReporte))}</span>`;
            if (fechaReporte) {
              html += `<span class="tabla-secundario">${fechaCelda(fechaReporte)} · ${haceCelda(fechaReporte)}</span>`;
            }

            // Fecha de alta
            html += dato.fechaAlta
              ? `<span class="tabla-secundario">Alta ${fechaCelda(dato.fechaAlta).slice(0, 10)}</span>`
              : `<span class="tabla-secundario no-info">Sin alta</span>`;

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            let html = '<div class="tabla-celda-col">';

            // Sección Alta
            if (dato.fechaAlta) {
              html += `<div>Alta: <strong>${fechaCelda(dato.fechaAlta)}</strong></div>`;
            } else {
              html += `<div>Sin fecha de alta</div>`;
            }

            // Sección Comunicación
            if (dato.ultimoReporte?.fechaCreacion) {
              html += `<div>Último reporte: <strong>${fechaCelda(dato.ultimoReporte.fechaCreacion)}</strong></div>`;

              const frecuenciaReporte = dato.tracker?.frecReporte;
              if (frecuenciaReporte) {
                html += `<div>Frecuencia de reporte: <strong>${frecuenciaReporte} min</strong></div>`;
              } else {
                html += `<div>Sin frecuencia de reporte configurada</div>`;
              }
            } else {
              html += `<div>Sin comunicación registrada</div>`;
            }

            html += '</div>';
            return html;
          },
        },
      },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      columnas.push({
        header: {
          label: 'Cliente',
        },
        row: {
          html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
          tooltip: (dato) =>
            this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          noData: 'Sin cliente',
        },
      });
    }

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        // Menú: Ver detalle · Editar · Eliminar · Más acciones ▸ (orden de
        // siempre; el submenú se conserva)
        accionesGrouped: [
          // Ver detalle
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalles(dato),
          },
          // Editar
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () => !this.helper.tienePermiso('Colectivos - Editar'),
          },
          // Eliminar
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso('Colectivos - Eliminar'),
          },
          {
            tipo: 'material',
            color: 'primary',
            icon: 'more_vert',
            tooltip: 'Más acciones',
            children: [
              // Exportar Eventos
              {
                tipo: 'material',
                color: 'primary',
                icon: 'file_download',
                tooltip: 'Exportar eventos',
                click: (dato) => this.exportarEventos(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Colectivos - Exportar eventos'),
              },
              // Exportar Reportes
              {
                tipo: 'material',
                color: 'primary',
                icon: 'description',
                tooltip: 'Exportar reportes',
                click: (dato) => this.exportarReportes(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Colectivos - Exportar Reportes'),
              },
              // Ubicar
              {
                tipo: 'material',
                color: 'primary',
                icon: 'map',
                tooltip: 'Ver en el mapa',
                disabled(dato) {
                  if (!dato.ultimoReporte?.valores?.geojson?.coordinates)
                    return true;
                  else return false;
                },
                click: (dato) => this.ubicar(dato),
              },
              // Setear Odometro
              {
                tipo: 'material',
                color: 'primary',
                icon: 'speed',
                tooltip: 'Setear odómetro',
                click: (dato) => this.setearOdometro(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Colectivos - Setear odómetro'),
              },
              // Servicio Técnico
              {
                tipo: 'material',
                color: 'primary',
                icon: 'build',
                tooltip: 'Servicio técnico',
                click: (dato) => this.eventoTecnico(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Colectivos - Solicitar servicio técnico',
                  ),
              },
              // Modo Desactivado
              {
                tipo: 'material',
                color: 'primary',
                icon: 'do_not_disturb_on',
                tooltip: 'Modo desactivado',
                click: (dato) => this.modoDesactivado(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Colectivos - Cambiar modo desactivado',
                  ),
              },
              // Dar de Alta
              {
                tipo: 'material',
                color: 'primary',
                icon: 'event_available',
                tooltip: 'Dar de alta',
                click: (dato) => this.darAlta(dato),
                oculta: (dato) => !!dato.fechaAlta,
                disabled: () =>
                  !this.helper.tienePermiso('Colectivos - Editar'), // TODO-PERMISOS crear permiso específico para dar de alta
              },
            ],
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }

    this.setColumnas();
    await Promise.all([
      this.listar(),
      this.listarTrackers(),
      this.listarChoferes(),
    ]);
  }

  ngOnDestroy() {
    this.activos$?.unsubscribe();
    this.reportes$?.unsubscribe();
    this.trackers$?.unsubscribe();
    this.grupos$?.unsubscribe();
    this.recorridos$?.unsubscribe();
    this.choferes$?.unsubscribe();
  }
}
